<script>
import i18n from "../i18n";
import { authComputed } from "@/state/helpers";

/**
 * Nav-bar Component - Admin Top Navigation
 * Đồng bộ style với HeaderNavBar.vue (trang public)
 */
export default {
  data() {
    return {
      url: `${process.env.VUE_APP_API_URL}filesminio/view/`,
      lan: i18n.locale,
      text: null,
      flag: null,
      value: null,
      myVar: 1,
      currentUserAuth: null,
    };
  },
  components: {},
  mounted() { },
  created() {
    let authUser = localStorage.getItem("auth-user");
    if (authUser) {
      let jsonUserCurrent = JSON.parse(authUser);
      this.currentUserAuth = jsonUserCurrent;
    }
  },
  methods: {
    switchLanguage(locale) {
      this.$i18n.locale = locale;
      localStorage.setItem('user-locale', locale);
    },
    toggleMenu() {
      this.$parent.toggleMenu();
    },
    toggleRightSidebar() {
      this.$parent.toggleRightSidebar();
    },
    initFullScreen() {
      document.body.classList.toggle("fullscreen-enable");
      if (
        !document.fullscreenElement &&
        !document.mozFullScreenElement &&
        !document.webkitFullscreenElement
      ) {
        if (document.documentElement.requestFullscreen) {
          document.documentElement.requestFullscreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullscreen) {
          document.documentElement.webkitRequestFullscreen(
            Element.ALLOW_KEYBOARD_INPUT
          );
        }
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }
      }
    },
    logoutUser() {
      var userLocalStorage = localStorage.getItem("user-token");
      if (userLocalStorage) {
        localStorage.removeItem("user-token");
        localStorage.removeItem("auth-user");
        localStorage.removeItem("menuItems");
        let checkTabData = localStorage.getItem("TabData");
        if (checkTabData) {
          localStorage.removeItem("TabData");
        }
        window.location.href = "/";
        return;
      }
    },
    handleThongTinCaNhan() {
      this.$router.push("/thong-tin-ca-nhan");
    },
  },
  computed: {
    ...authComputed,
  },
};
</script>

<template>
  <header id="page-topbar" class="admin-topbar">
    <div class="navbar-header admin-navbar">
      <div class="d-flex align-items-center">
        <!-- LOGO -->
        <!-- <div class="navbar-brand-box">
          <router-link to="/" class="logo logo-dark">
            <span class="logo-sm">
              <img src="@/assets/images/logo-con.png" alt height="22" />
            </span>
            <span class="logo-lg">
              <img src="@/assets/images/logo-con.png" alt height="17" />
            </span>
          </router-link>
          <router-link to="/" class="logo logo-light">
            <span class="logo-sm">
              <img src="@/assets/images/logo-con.png" alt height="30" />
            </span>
            <span class="logo-lg">
              <img src="@/assets/images/logo-con.png" alt height="55" />
            </span>
          </router-link>
        </div> -->

        <!-- Toggle Menu Button -->
        <button id="vertical-menu-btn" type="button" class="btn btn-sm px-3 font-size-16 header-item btn-toggle-menu"
          @click="toggleMenu">
          <i class="fa fa-fw fa-bars"></i>
        </button>

        <!-- App Title -->
        <div class="admin-app-title">
          Lễ hội trái cây tỉnh Đồng Tháp
        </div>
      </div>


      <div class="d-flex align-items-center">
        <!-- User Dropdown -->
        <b-dropdown right class="popup-dropdown" variant="black" toggle-class="" menu-class="dropdown-menu-end">
          <template v-slot:button-content>
            <span class="d-none d-xl-inline-block ms-1 mt-3">
              <div v-if="currentUserAuth" class="user-dropdown-text">
                <div class="user-fullname">
                  {{ currentUserAuth.fullName }}
                  <i class="mdi mdi-chevron-down d-none d-xl-inline"></i>
                </div>
                <div class="user-username text-start">@{{ currentUserAuth.userName }}</div>
              </div>
              <div v-else class="user-fullname">ẨN DANH</div>
            </span>
          </template>

          <!-- Thông tin cá nhân -->
          <b-dropdown-item>
            <a v-on:click="handleThongTinCaNhan">
              <span>
                <i class="bx bx-user font-size-16 align-middle me-1"></i>
                Thông tin cá nhân
              </span>
            </a>
          </b-dropdown-item>

          <b-dropdown-divider></b-dropdown-divider>

          <!-- Đăng xuất -->
          <a v-on:click="logoutUser" class="dropdown-item text-danger" style="cursor: pointer">
            <i class="bx bx-power-off font-size-16 align-middle me-1 text-danger"></i>
            Đăng xuất
          </a>
        </b-dropdown>
      </div>
    </div>
  </header>
</template>

<style scoped>
/* =========================================
   ADMIN TOP NAVBAR
   Đồng bộ palette với HeaderNavBar (public)
   Sử dụng biến CSS chuẩn: --primary, --surface, --on-surface-variant
   ========================================= */

.admin-topbar {
  /* Override background: dùng --primary thay vì hardcode */
}

.admin-navbar {
  background: var(--primary, #0d631b) !important;
}

/* Toggle Menu Button */
.btn-toggle-menu {
  color: var(--on-primary, #ffffff);
  transition: opacity 0.2s;
}

.btn-toggle-menu:hover {
  opacity: 0.8;
}

/* App Title - Đồng bộ font với HeaderNavBar .logo-text */
.admin-app-title {
  font-family: var(--font-heading, "Montserrat");
  font-weight: 700;
  font-size: 15px;
  color: var(--on-primary, #ffffff);
  display: flex;
  align-items: center;
}

/* User Dropdown Text */
.user-dropdown-text {
  font-size: 10px;
  color: var(--on-primary, #ffffff);
}

.user-fullname {
  font-size: 12px;
  color: var(--on-primary, #ffffff);
}

.user-username {
  font-size: 10px;
  color: rgba(255, 255, 255, 0.7);
}

/* Header item images fix */
.header-item img {
  margin-top: 13px;
}
</style>
